import React from "react";

const COLUMNS = [
  { id: "manager", label: "Regular Manager" },
  { id: "bot", label: "Generic AI Bot" },
  { id: "employee", label: "Roofing Digital Employee" },
];

const ROWS = [
  {
    id: "response",
    parameter: "Response Time",
    manager: "4 hr 12 min (at night / on the roof)",
    bot: "5–10 seconds",
    employee: "Under 26 seconds, 24/7/365",
  },
  {
    id: "knowledge",
    parameter: "Roofing Knowledge",
    manager: "Requires training",
    bot: "None (uses generic responses)",
    employee: "100% Roofing-Specific",
  },
  {
    id: "qualification",
    parameter: "Lead Qualification",
    manager: "Depends on the individual",
    bot: "Loses leads to a form",
    employee: "Qualifies leads & books roof inspections",
  },
  {
    id: "cost",
    parameter: "Cost",
    manager: "$3,500/mo + commission",
    bot: "$50/mo (doesn't sell)",
    employee: "Fixed subscription ($0 for first 14 days)",
  },
];

const ComparisonSection = () => (
  <section className="cursor-section roofing-comparison" data-testid="roofing-comparison-section">
    <div className="roofing-comparison-inner">
      <h2 className="roofing-comparison-title" data-testid="roofing-comparison-headline">
        Human Employee vs. Generic AI vs.{" "}
        <span className="roofing-comparison-gain">FractoLabs Digital Employee</span>
      </h2>

      <div className="roofing-comparison-table-wrap" data-testid="roofing-comparison-table">
        <table className="roofing-comparison-table">
          <thead>
            <tr>
              <th scope="col">Parameter</th>
              {COLUMNS.map((column) => (
                <th key={column.id} scope="col">
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((row) => (
              <tr key={row.id} data-testid={`roofing-comparison-row-${row.id}`}>
                <th scope="row">{row.parameter}</th>
                <td>{row.manager}</td>
                <td>{row.bot}</td>
                <td>{row.employee}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="roofing-comparison-cards" data-testid="roofing-comparison-cards">
        {ROWS.map((row) => (
          <article key={row.id} className="roofing-comparison-card" data-testid={`roofing-comparison-card-${row.id}`}>
            <h3 className="roofing-comparison-card-title">{row.parameter}</h3>
            {COLUMNS.map((column) => (
              <div
                key={column.id}
                className={`roofing-comparison-card-value${
                  column.id === "employee" ? " roofing-comparison-card-value-highlight" : ""
                }`}
              >
                <p className="roofing-comparison-card-label">{column.label}</p>
                <p className="roofing-comparison-card-text">{row[column.id]}</p>
              </div>
            ))}
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ComparisonSection;
